import { render } from "./Chart_Of_Accounts2.vue?vue&type=template&id=6f149995&scoped=true"
import script from "./Chart_Of_Accounts2.vue?vue&type=script&lang=js"
export * from "./Chart_Of_Accounts2.vue?vue&type=script&lang=js"

import "./Chart_Of_Accounts2.vue?vue&type=style&index=0&id=6f149995&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f149995"]])

export default __exports__